// extracted by mini-css-extract-plugin
export var card = "_sj-0";